import React from "react";
import myRestClient from "../common/restClient";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import restClient from "../common/restClient";
import Button from "@material-ui/core/Button";
import DoneIcon from "@material-ui/icons/Done";
import CancelIcon from "@material-ui/icons/Cancel";
import DisableIcon from "@material-ui/icons/Block";
import { withStyles } from "@material-ui/core/styles";
import grey from "@material-ui/core/colors/grey";
import Select from "react-select";
import tccStyles from "../common/styles";

const postRowStyle = record => ({
    backgroundColor: record.disabled ? grey[100] : "white"
});

const postCellStyle = record => ({
    color: record.disabled ? grey[400] : "black"
});

const styles = theme => ({
    dialog: {
        display: "flex",
        flexDirection: "column",
        margin: "auto"
    }
});

const selectStyles = {
    option: (provided, state) => ({
        ...provided,
        color: tccStyles.colors.black,
        padding: 20,
        backgroundColor: state.isSelected
            ? tccStyles.colors.lightgrey
            : tccStyles.colors.white,
        ":active": {
            backgroundColor:
                state.isSelected || state.isFocused
                    ? tccStyles.colors.lightgrey
                    : tccStyles.colors.white
        },
        ":hover": {
            backgroundColor: tccStyles.colors.lightgrey
        }
    }),
    control: (provided, state) => ({
        ...provided,
        borderRadius: 0,
        border: state.isFocused ? 0 : 0,
        boxShadow: state.isFocused ? 0 : 0,
        "&:hover": {
            border: state.isFocused ? 0 : 0
        }
    }),
    indicatorSeparator: () => ({
        display: "none"
    }),
    dropdownIndicator: (provided, state) => ({
        color: tccStyles.colors.main
    }),
    menu: (provided, state) => ({
        ...provided,
        position: "absolute",
        zIndex: 1100
    })
};

class CompanyField extends React.Component {
    state = { id: null, name: null, disabled: true };

    componentDidMount() {
        const { id, row } = this.props;
        this.setState({ disabled: row.disabled });
        myRestClient("GET_ONE", "companies", {
            id: id
        }).then(
            result => {
                this.setState({
                    name: result.data.name,
                    id: id
                });
            },
            error => {
                console.log(error);
            }
        );
    }
    componentWillUpdate() {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.disabled = this.props.row.disabled;
    }
    componentDidUpdate() {
        if (this.state.id && this.props.row.company_id !== this.state.id) {
            const { id, row } = this.props;
            myRestClient("GET_ONE", "companies", {
                id: row.company_id
            }).then(
                result => {
                    this.setState({
                        name: result.data.name,
                        id: id
                    });
                },
                error => {
                    console.log(error);
                }
            );
        }
    }
    render() {
        return (
            <TableCell
                style={{
                    color: this.state.disabled ? grey[400] : "black"
                }}
                component="th"
                scope="row"
            >
                {this.state.name}
            </TableCell>
        );
    }
}
class EnableDeleteButton extends React.Component {
    state = { canBeDeleted: false };
    componentDidMount() {
        const { row } = this.props;
        myRestClient("GET_ONE", "companies", {
            id: row.company_id
        }).then(
            result => {
                this.setState({
                    canBeDeleted: result.data.deleted
                });
            },
            error => {
                console.log(error);
            }
        );
    }
    render() {
        const { classes } = this.props;
        return (
            <div>
                {!this.state.canBeDeleted && (
                    <Button
                        {...this.props}
                        style={{ color: "green" }}
                        id={this.props.row.company_id}
                        onClick={e => {
                            this.props.handleEnable(e, this.props.row);
                        }}
                    >
                        Abilita
                        <DoneIcon className={classes.rightIcon} />
                    </Button>
                )}
                {this.state.canBeDeleted && (
                    <Button
                        style={{ color: "red" }}
                        onClick={e => {
                            this.props.handleDelete(e, this.props.row);
                        }}
                    >
                        Cancella
                        <CancelIcon className={classes.rightIcon} />
                    </Button>
                )}
            </div>
        );
    }
}

class CustomerMappingGrid extends React.Component {
    state = {
        clientMappings: [],
        serverMappings: [],
        showCompanyDialog: false,
        selectedCompany: null,
        isFetchingSelectValues: false
    };

    fetchCompanySelectValues = () => {
        const params = {
            pagination: { page: 1, perPage: 10000 },
            sort: { field: "name", order: "asc" }
        };
        restClient("GET_LIST", "companies", params).then(
            result => {
                const dataIds = result.data.map(item => {
                    return item.id;
                });
                const mappingsIds = this.state.clientMappings.map(item => {
                    return item.company_id;
                });
                const updatedIds = dataIds.filter(id => {
                    return mappingsIds.includes(id) === false ? id : null;
                });
                const selectCompanies = result.data.filter(item => {
                    return updatedIds.includes(item.id) ? item : null;
                });
                const selectItems = selectCompanies.map(item => {
                    return { value: item.id, label: item.name };
                });
                this.setState({
                    selectValues: selectItems,
                    isFetchingSelectValues: false
                });
            },
            error => {
                return error;
            }
        );
    };

    fetchMappings = () => {
        const { resourceId, input } = this.props;
        if (!resourceId || !input) {
            this.fetchCompanySelectValues();
            return;
        }
        const params = {
            pagination: { page: 1, perPage: 10000 },
            sort: { field: "name", order: "asc" },
            filter: { customer_id: resourceId }
        };
        restClient("GET_LIST", "customers-mappings", params).then(
            result => {
                const serverMappings = result.data.map(item => {
                    return item;
                });
                input && input.onChange(serverMappings);
                this.setState({
                    serverMappings: serverMappings,
                    clientMappings: result.data
                });
                this.fetchCompanySelectValues();
            },
            error => {
                return error;
            }
        );
    };

    componentDidMount() {
        this.fetchMappings();
    }

    handleDisable = (e, row) => {
        const oldMappings = this.state.clientMappings;
        const mappings = oldMappings.map(item => {
            if (item.company_id === row.company_id) {
                item.disabled = true;
            }
            return item;
        });
        this.props.input && this.props.input.onChange(mappings);
        this.setState({ clientMappings: mappings });
    };

    handleDelete = (e, row) => {
        const { input } = this.props;
        const oldMappings = this.state.clientMappings;
        const mappings = oldMappings.map(item => {
            if (item.company_id === row.company_id) {
                item.deleted = true;
            }
            return item;
        });
        input && input.onChange(mappings);
        this.setState({ clientMappings: mappings });
    };

    handleEnable = (e, row) => {
        const { input } = this.props;
        const oldMappings = this.state.clientMappings;
        const mappings = oldMappings.map(item => {
            if (item.company_id === row.company_id) {
                item.disabled = false;
            }
            return item;
        });
        input && input.onChange(mappings);
        this.setState({ clientMappings: mappings });
    };

    handleRowOk = value => {
        const { input } = this.props;
        const customer_id = parseInt(this.props.redirectQuery, 10);
        const company_id = value;
        const newMapping = {
            active_installations: 0,
            booked_installations: 0,
            company_id: company_id,
            customer_id: customer_id,
            disabled: false
        };
        const mappings = this.state.clientMappings;
        mappings.push(newMapping);
        input && input.onChange(mappings);
        this.fetchCompanySelectValues();
        this.setState({
            clientMappings: mappings,
            isFetchingSelectValues: true
        });
    };

    setCompanyValue = item => {
        if (item) {
            this.handleRowOk(item.value);
        }
    };

    handleDeleteClientMapping = row => {
        const { input } = this.props;
        const oldMappings = this.state.clientMappings;
        const mappings = oldMappings.filter(item => {
            return item.company_id !== row.company_id ? item : null;
        });
        const sanitizedInputValue = mappings.length > 0 ? mappings : null;
        input && input.onChange(sanitizedInputValue);
        this.setState({ clientMappings: mappings });
        this.fetchCompanySelectValues();
    };

    renderNewRowSelect() {
        return (
            <div>
                <Select
                    isLoading={this.state.isFetchingSelectValues}
                    isSearchable={true}
                    name="color"
                    onChange={this.setCompanyValue}
                    options={this.state.selectValues}
                    styles={selectStyles}
                    placeholder={"Seleziona un'azienda"}
                />
            </div>
        );
    }

    renderEmptyRow(id) {
        return (
            <TableRow key={id + 1}>
                <TableCell align="left">{this.renderNewRowSelect()}</TableCell>
                <TableCell align="right">0</TableCell>
                <TableCell align="right">0</TableCell>
                <TableCell />
            </TableRow>
        );
    }

    renderCellButton(row, classes) {
        const isServer = this.state.serverMappings.find(item => {
            return item.company_id === row.company_id;
        })
            ? true
            : false;
        switch (isServer) {
            case true: {
                if (row.disabled === true && row.deleted !== true) {
                    const buttons = (
                        <React.Fragment>
                            <EnableDeleteButton
                                handleDelete={this.handleDelete}
                                handleEnable={this.handleEnable}
                                row={row}
                                {...this.props}
                            />
                        </React.Fragment>
                    );
                    return buttons;
                } else if (row.disabled === false) {
                    return (
                        <Button
                            style={{ color: "red" }}
                            onClick={e => {
                                this.handleDisable(e, row);
                            }}
                        >
                            Disabilita
                            <DisableIcon className={classes.rightIcon} />
                        </Button>
                    );
                } else if (row.deleted === true) {
                    return (
                        <Button disabled={true}>
                            <DisableIcon />
                            CANCELLATO
                        </Button>
                    );
                }
                break;
            }
            case false: {
                return (
                    <Button
                        style={{ color: "red" }}
                        onClick={e => {
                            this.handleDeleteClientMapping(row);
                        }}
                    >
                        <CancelIcon />
                        Annulla
                    </Button>
                );
            }
            default:
                return null;
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Ragione Sociale</TableCell>
                        <TableCell align="right">
                            Installazioni prenotate
                        </TableCell>
                        <TableCell align="right">
                            Installazioni attive
                        </TableCell>
                        <TableCell align="right" />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.clientMappings.map(row => (
                        <TableRow style={postRowStyle(row)} key={row.id}>
                            <CompanyField row={row} id={row.company_id} />
                            <TableCell style={postCellStyle(row)} align="right">
                                {row.booked_installations}
                            </TableCell>
                            <TableCell style={postCellStyle(row)} align="right">
                                {row.active_installations}
                            </TableCell>
                            <TableCell align="right">
                                {this.renderCellButton(row, classes)}
                            </TableCell>
                        </TableRow>
                    ))}
                    {this.renderEmptyRow(this.state.clientMappings.length)}
                </TableBody>
            </Table>
        );
    }
}

export default withStyles(styles)(CustomerMappingGrid);



// WEBPACK FOOTER //
// ./src/components/CustomerMappingGrid.js